import React from "react";

export default function PersonalDescription({userDescription,setUserDescription}) {
  const max_chars = 200;
  const [charsLeft, setCharsLeft] = React.useState(max_chars);

  const onChangeHandler = (event) => {
    const { name, value } = event.currentTarget;
    if (name ==="userDescriptionExp"){
      var input = event.target.value;
      setCharsLeft(max_chars - input.length);
      setUserDescription({...userDescription,[name]: value});
    }
  }
  return (
    <div>
      <div className="header-and-save">
        <h3>תיאור כללי</h3>
      </div>

      <div className="update-page-contact">
        <label className="profile-update-label">
          אנא פרט בקצרה אודות ניסיון והתמחות ייחודית (ככל שיש לך)
        </label>
        <div className="profile-update-labelinput-wrapper">
          <textarea
            name="userDescriptionExp"
            maxLength = {max_chars}
            style={{ width: "400px", height: "135px" }}
            className="profile-update-input"
            value = {userDescription.userDescriptionExp}
            onChange={event => onChangeHandler(event)}
          ></textarea>
        </div>
        <p className="profile-update-label">תווים שנשארו: {charsLeft}</p>
      </div>
    </div>
  );
}
